export default "__VITE_ASSET__DZ_wqq4R__"